

import React from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";
import BASIC_INFORMATION from "../core/data/basic";
import {Link} from "react-router-dom";
import QRCode from "react-qr-code";
import INFO from "../core/data/basic";
import Zoom from "react-medium-image-zoom";

function ContactsPage(props) {

    const { t, i18n } = useTranslation()

    const _contacts = [
        {
            title: "Phone",
            username: INFO.phoneLifecell,
            url: "tel:" + INFO.phoneLifecell
        },
        {
            title: "E-Mail",
            username: INFO.email,
            url: "mailto:" + INFO.email
        },
        {
            title: "LinkedIn",
            username: 'a028481ab',
            url: INFO.socialLinkedIn
        },
        {
            title: "GitHub",
            username: "@yarikthe",
            url: INFO.socialGitHub
        }
    ]

    return (<div className={'min-vh-100 pt-5'}>

        <Helmet>
            <title>{t('nav.contacts')} - {t('me.name')}</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start">

            <h1 className={'opacity-25 mb-5'} style={{fontSize: '5vw'}}>{t('nav.contacts')}</h1>

            <div className="d-flex justify-content-between align-items-center flex-wrap mt-5 mb-5">

                {
                    _contacts.map((contact, i) => <div className="col-md-auto col-6">
                        <Zoom>
                            <QRCode
                                size={256}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                value={contact.url}
                                viewBox={`0 0 256 256`}
                            />
                        </Zoom>
                        <div className="text-center w-100">
                            <small>{contact.username}</small>
                            <p className={'display-6'}>
                                <Link to={contact.url} className={'nav-link text-secondary'} target={'_blank'}>{contact.title}</Link>
                            </p>
                        </div>
                    </div>)
                }

            </div>

        </div>
    </div>);
}

export default ContactsPage;
